import { getLiveUrl, getNewLiveUrl, checkUser } from "../../api/forum";
import {MessageBox} from 'element-ui';
import Cookies from "js-cookie";
import { language } from "@/language/get";
const live = {
  state: {
    client_id: ''
  },
  mutations: {
    setClientId: (state, client_id) => {
      state.client_id = client_id;
    }
  },
  actions: {
    //进入直播间获取相关参数
    getLiveInfo({ commit }, liveInfo) {
      return new Promise((resolve, reject) => {
        getLiveUrl(liveInfo).then(res => {
          // if (res.type == '1') {
          //   commit("SET_SIGN",)
          // }
          if (res.type == 11){
            MessageBox({
              title: "",
              message: Cookie.get("lang")=='ch'?res.text:res.text_en,
              confirmButtonText: language().confirm,
              cancelButtonText: language().cancel,
              showCancelButton: false,
              // type: 'success'
            }).then(() => {
              //确认
            }).catch(() => {
              //取消
            });
          }
          resolve(res);
        }).catch(err => reject(err))
      })
    },
    //新进入直播间获取相关参数
    getNewLiveUrl({ commit }, liveInfo) {
      return new Promise((resolve, reject) => {
        getNewLiveUrl(liveInfo).then(res => {
          // if (res.type == '1') {
          //   commit("SET_SIGN",)
          // }
          resolve(res);
        }).catch(err => reject(err))
      })
    }
  }
};

export default live;
